/** @format */

import React, { Component } from 'react';
import { Segment, Divider, Grid, Table } from 'semantic-ui-react';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';

@inject('RequestsStore')
@observer
class RequestPartLayout extends Component {
  renderContent = content => {
    if (content !== undefined && content !== null && content !== '') {
      return content;
    } else {
      return '-';
    }
  };

  render() {
    const { RequestsStore, partId } = this.props;
    const currentReqPart = RequestsStore.currentRequest.reqParts[partId];
    return (
      <Segment padded className="reqPart-box" size="small" key="request-parts">
        {this.props.image}
        <Grid>
          <Grid.Row className="reqPart-head">
            <Grid.Column computer="13">{this.props.header}</Grid.Column>
            <Grid.Column
              className="action-icons"
              computer="3"
              textAlign="right"
            >
              {this.props.removePartButton}&nbsp;&nbsp;&nbsp;
              {this.props.editPartButton}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider />
        <Table compact basic="very" fixed celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Zona Magazzino</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.whCode)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Cod. Prodotto</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.productCode)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Nome</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.part)}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Casa</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.carMaker)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Modello</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.carModel)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Colore</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.color)}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell colSpan={1}>
                <small>
                  <strong>Lato Auto</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.carSide)}
              </Table.Cell>
              <Table.Cell colSpan={1}>
                <small>
                  <strong>{intl.get('parts.labels.part_conditions')}</strong>
                </small>
                <br />
                {this.renderContent(
                  intl.get(
                    `parts.conditions.${currentReqPart.data.partCondition}`,
                  ),
                )}
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <small>
                  <strong>Note</strong>
                </small>
                <br />
                {this.renderContent(currentReqPart.data.notes)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        {this.props.toggleOptionButton}
        {this.props.requestPartOptions}
      </Segment>
    );
  }
}

export default RequestPartLayout;
